import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LinkClickState {
  clickedLinks: Set<string>;
  addClickedLink: (stageItemId: string) => void;
  hasLinkBeenClicked: (stageItemId: string) => boolean;
  clearClickedLinks: () => void;
  removeClickedLink: (stageItemId: string) => void;
}

export const useLinkClickStore = create<LinkClickState>()(
  persist(
    (set, get) => ({
      clickedLinks: new Set<string>(),

      addClickedLink: (stageItemId: string) => {
        set((state) => ({
          clickedLinks: new Set([...state.clickedLinks, stageItemId]),
        }));
      },

      hasLinkBeenClicked: (stageItemId: string) => {
        return get().clickedLinks.has(stageItemId);
      },

      clearClickedLinks: () => {
        set({ clickedLinks: new Set<string>() });
      },

      removeClickedLink: (stageItemId: string) => {
        set((state) => {
          const newClickedLinks = new Set(state.clickedLinks);
          newClickedLinks.delete(stageItemId);
          return { clickedLinks: newClickedLinks };
        });
      },
    }),
    {
      name: 'zee-link-clicks',
      partialize: (state) => ({
        clickedLinks: Array.from(state.clickedLinks),
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.clickedLinks = new Set(
            state.clickedLinks as unknown as string[]
          );
        }
      },
    }
  )
);
